

export const SET_PAGE = 'SET_PAGE';
export const SET_FILTERS = 'SET_FILTER';
export const SET_TAB = 'SET_TAB';
export const SET_DIRECTION = 'SET_DIRECTION';
export const UPDATE_DATA = 'UPDATE_DATA';
export const SET_LOADING_SHIPMENTS = 'SET_LOADING_SHIPMENTS';
export const SET_BROKER_JOBS = 'SET_BROKER_JOBS';
export const SET_TOTAL_NUMBER_OF_JOBS = 'SET_TOTAL_NUMBER_OF_JOBS';
export const GET_DOCUMENT_TYPES = 'GET_DOCUMENT_TYPES';
export const CURRENT_JOB_STATE = 'CURRENT_JOB_STATE';
export const ADD_NEW_TANSIT_CARD = 'ADD_NEW_TANSIT_CARD';
export const INITIATE_DATA = 'INITIATE_DATA'
export const DELETE_DATA = 'DELETE_DATA'
export const DISPLAY_UPDATE_FORM = 'DISPLAY_UPDATE_FORM'
export const INITIATE_MAIN_FORM = 'INITIATE_MAIN_FORM'
export const UPDATE_PGA_DATA = 'UPDATE_PGA_DATA'
export const UPDATE_MAIN_FORM = 'UPDATE_MAIN_FORM'
export const INITIATE_PGA_DATA = 'INITIATE_PGA_DATA'
export const UPDATE_REPEATED_FIELD = 'UPDATE_REPEATED_FIELD'
export const UPDATE_REPEATED_SUB_FIELD = 'UPDATE_REPEATED_SUB_FIELD'
export const UPDATE_REPEATED_SUB_SUB_FIELD = 'UPDATE_REPEATED_SUB_SUB_FIELD'
export const UPDATE_LACEY_ACT_FIELD = 'UPDATE_LACEY_ACT_FIELD'
export const UPDATE_PGA_ITEM_FIELD = 'UPDATE_PGA_ITEM_FIELD'
export const INITIATE_DYNAMIC_PGA_DATA = 'INITIATE_DYNAMIC_PGA_DATA'
export const UPDATE_DYNAMIC_PGA_DATA = 'UPDATE_DYNAMIC_PGA_DATA'
export const UPDATE_DYNAMIC_REPEATED_SUB_FIELD = 'UPDATE_DYNAMIC_REPEATED_SUB_FIELD'
export const UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD = 'UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD'
export const UPDATE_DYNAMIC_LACEY_FIELD = 'UPDATE_DYNAMIC_LACEY_FIELD'
export const UPDATE_DYNAMIC_PGA_ITEM_FIELD = 'UPDATE_DYNAMIC_PGA_ITEM_FIELD'
export const UPDATE_DYNAMIC_REPEATED_FIELD = 'UPDATE_DYNAMIC_REPEATED_FIELD'
export const MARK_OSOLETE_ICON = 'MARK_OSOLETE_ICON'
export const UPDATE_DOC_ARR = 'UPDATE_DOC_ARR'
export const UPDATE_POPUP_TYPE = 'UPDATE_POPUP_TYPE'
export const UPDATE_POPUP_OPEN = 'UPDATE_POPUP_OPEN'
export const RESET_OBSO_STATE = 'RESET_OBSO_STATE'
export const ADD_REPEATED_DYNAMIC_PGA_ITEM = 'ADD_REPEATED_DYNAMIC_PGA_ITEM'
export const REMOVE_REPEATED_GROUP = 'REMOVE_REPEATED_GROUP'
export const REPLACE_ALL_REPEATED_ITEM_DYNAMIC = 'REPLACE_ALL_REPEATED_ITEM_DYNAMIC'
export const ADD_REPEATED_SUB_FIELD_DYNAMIC = 'ADD_REPEATED_SUB_FIELD_DYNAMIC'
export const REMOVE_SUB_FIELD_GROUPS_DYNAMIC = 'REMOVE_SUB_FIELD_GROUPS_DYNAMIC'

//  For manage Dropdowns
export const ADD_DROPDOWN_DATA = "ADD_DROPDOWN_DATA"
export const INITIALIZE_DROPDOWNTYPE_DROPDOWN = "INITIALIZE_DROPDOWNTYPE_DROPDOWN"
export const GET_DROPDOWN_LIST_BY_TYPE = "GET_DROPDOWN_LIST_BY_TYPE"
export const HANDLE_EDITABLE_ROW_ID = "HANDLE_EDITABLE_ROW_ID"
export const UPDATE_DROPDOWN_DATA_FIELDS = "UPDATE_DROPDOWN_DATA_FIELDS"
export const SAVE_DROPDOWN_VALUE = "SAVE_DROPDOWN_VALUE"
export const HANDLE_CANCEL = "HANDLE_CANCEL"
export const CLEAR_DATA = "CLEAR_DATA"
export const SET_DROPDOWN_TYPE = "SET_DROPDOWN_TYPE"
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE"
